__webpack_require__.p = "/studentiqtest/";